<template>
  <div
    :class="`formulate-input-element password-field formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <input
      type="password"
      v-model="context.model"
      v-bind="context.attributes"
      autocomplete="no"
      @keypress="space($event)"
      v-onlyNumber
    />
  </div>
</template>

<script>
export default {
  name: "NumberInput",
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  methods: {
    space(e) {
      if (e.keyCode == 32) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
